var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"m-t-md m-b-xs"},[_vm._v("Kategorie")]),_vm._v(" "),_c('div',{staticClass:"m-b"},[_c('div',{attrs:{"id":"jstree"}},[_c('ul',[_c('tree-node',{staticClass:"jstree-open",attrs:{"node":_vm.categories,"label":"Alle","children-collapsed":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }